module.exports = __webpack_public_path__ + "img/hotel-29.47dc7c6e.jpeg";